import React from "react";
import { Box, Button, Chip, CircularProgress, Tooltip, Typography } from "@material-ui/core";

export const statusColor = (status) => {
  if (status === "running") return "primary";
  if (status === "error") return "secondary";
  return "default";
};

const AgentStatusControls = ({
  status,
  onStart,
  onPause,
  onStop,
  onPreviewAgent,
  disabled = false,
  previewLoading = false,
  startDisabled = false,
  startDisabledReason = "",
  starting = false,
  startPhaseMessage = "",
  buttonsOnly = false,
}) => {
  const startBlocked = disabled || status === "running" || startDisabled || starting;
  const startLabel = starting
    ? startPhaseMessage || "Starting…"
    : "Start";
  const startButton = (
    <Button
      size="small"
      variant="contained"
      color="primary"
      onClick={onStart}
      disabled={startBlocked}
      startIcon={
        starting ? <CircularProgress size={14} color="inherit" /> : undefined
      }
      style={starting ? { minWidth: 160, justifyContent: "flex-start" } : undefined}
    >
      {startLabel}
    </Button>
  );

  const buttons = (
    <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 12 }}>
      {!starting && startDisabled && startDisabledReason ? (
        <Tooltip title={startDisabledReason} placement="top">
          <span style={{ display: "inline-flex" }}>{startButton}</span>
        </Tooltip>
      ) : (
        startButton
      )}
      <Button
        size="small"
        variant="outlined"
        onClick={onPause}
        disabled={disabled || starting || status !== "running"}
      >
        Pause
      </Button>
      <Button
        size="small"
        variant="outlined"
        onClick={onPreviewAgent}
        disabled={disabled || starting || previewLoading}
      >
        {previewLoading ? "Previewing…" : "Preview Agent"}
      </Button>
    </Box>
  );

  if (buttonsOnly) return buttons;

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" style={{ columnGap: 16, rowGap: 12 }}>
      <Box display="flex" alignItems="center" gridGap={8}>
        <Typography variant="subtitle1">Status</Typography>
        <Chip size="small" color={statusColor(status)} label={(status || "draft").toUpperCase()} />
      </Box>
      {buttons}
    </Box>
  );
};

export default AgentStatusControls;
